import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross1 } from "react-icons/rx";
import NavLinks from "./NavLinks";

function Navbar() {
  const [active, setActive] = useState(false);
  const [navbarClass, setNavbarClass] = useState("bg-white/30");
  const [textClass, setTextClass] = useState("text-blue-950");
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setNavbarClass("bg-blue-950");
        setTextClass("text-white");
      } else {
        setNavbarClass("bg-white/30");
        setTextClass("text-blue-950");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => setActive(!active);
  return (
    <nav
      className={`py-5 items-center px-10 z-50 fixed top-0 w-full transition-colors ${navbarClass}`}
    >
      <div className="flex items-center font-medium justify-between">
        <div className="z-50 p-5 md:w-auto w-full flex justify-between">
          <Link
            to="/"
            className="md:cursor-pointer text-2xl font-bold text-red-600"
          >
            StudentKeja
          </Link>
          <div className="md:hidden" onClick={toggleMenu}>
            {active ? (
              <RxCross1
                onClick={toggleMenu}
                className={`text-2xl ${textClass}`} />
            ) : (
              <GiHamburgerMenu
                onClick={toggleMenu}
                className={`text-2xl ${textClass}`} />
            )}
          </div>
        </div>

        <ul
          className={`md:flex hidden items-center gap-8 font-bold border-x-4 border-red-500 ${textClass}`}
        >
          <NavLinks />
        </ul>
        <ul
          className={`md:hidden border-x-4 border-red-500 fixed h-1/2 w-full overflow-y-auto pl-4 top-20
        duration-300 ${navbarClass} ${textClass} ${active ? `-right-[0%]` : `-right-[100%]`}
        `}
        >
          <NavLinks />
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
